const showFurigana = {
    namespaced: true,
    state: {
        isShowFurigana: true
    },
    mutations: {
        TOGGLE_SHOW(state) {
            state.isShowFurigana = !state.isShowFurigana
        }
    },
    actions: {
        handleToggleShow(context) {
            context.commit('TOGGLE_SHOW')
        }
    },
    getters: {
        getStatusFuri(state) {
            return state.isShowFurigana
        }
    },
};

export default showFurigana;


// WEBPACK FOOTER //
// ./src/stores/modules/showFurigana.js